/**
 * Servicio para catálogo de líneas comerciales
 */

import api from './api.js';

class LineaComercialService {
  async listar(params = {}) {
    return await api.get('/lineas-comerciales', params);
  }

  // Detalle con controles y atributos de la línea (ERP F1)
  async obtener(codigo) {
    return await api.get(`/lineas-comerciales/${encodeURIComponent(codigo)}`);
  }

  async crear(data) {
    return await api.post('/lineas-comerciales', data);
  }

  async actualizar(codigo, data) {
    return await api.put(`/lineas-comerciales/${codigo}`, data);
  }

  // Toggle activo (pausa/reanuda) — patrón cambiar_estado
  async desactivar(codigo) {
    return await api.patch(`/lineas-comerciales/${codigo}/desactivar`);
  }

  async reactivar(codigo) {
    return await api.patch(`/lineas-comerciales/${codigo}/reactivar`);
  }

  // Soft delete real (deleted_at) — patrón eliminar
  async eliminar(codigo) {
    return await api.delete(`/lineas-comerciales/${codigo}`);
  }

  async restaurar(codigo) {
    return await api.post(`/lineas-comerciales/${codigo}/restaurar`);
  }
}

export default new LineaComercialService();
